export { default as EligibilityCriteriaComponent } from './EligibilityCriteria'
